/**
 * 얼굴 가이드 (HERIT 03) — 560×720 뷰박스. 바깥 타원(잉크 2.4) + 안쪽 점선 타원(line-2 1.6, dash 6 10) + 상하좌우 틱.
 * 라이브 카메라 위에 올라가므로 pointer-events 는 CSS 에서 none.
 */
export function FaceGuide({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 560 720" aria-hidden focusable="false">
      <ellipse cx="280" cy="360" rx="276" ry="356" fill="none" stroke="var(--color-ink)" strokeWidth="2.4" />
      <ellipse
        cx="280"
        cy="360"
        rx="236"
        ry="312"
        fill="none"
        stroke="var(--color-line-2)"
        strokeWidth="1.6"
        strokeDasharray="6 10"
      />
      <g stroke="var(--color-ink)" strokeWidth="1.6">
        <line x1="280" y1="0" x2="280" y2="40" />
        <line x1="280" y1="680" x2="280" y2="720" />
        <line x1="0" y1="360" x2="44" y2="360" />
        <line x1="516" y1="360" x2="560" y2="360" />
      </g>
    </svg>
  );
}
